import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Tooltip,
} from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import { Box } from "@mui/system";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AccordianContainer from "../../CustomComponents/AccordianContainer";
import CustomAutoComplete from "../../CustomComponents/CustomAutoComplete";
import CustomDateField from "../../CustomComponents/CustomDateField";
import GetBranchDetails from "../../CustomComponents/GetBranchDetails";
import GetBranchDetailsWithCode from "../../CustomComponents/GetBranchDetailsWithCode";
import { FilePaymentModeReducerAction } from "../../Store/FilePayment/FilePaymentModeReducer";
import { FilePaymentModifyReducerAction } from "../../Store/FilePayment/FilePaymentModifyReducer";
import { BranchAction } from "../../Store/Branch";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { CommonShortCutAction } from "../../Store/CommonShortCutsReducer";

const FilePaymentFIl = () => {
  //Declaring dispatch
  const dispatch = useDispatch();
  const [DialogOpen, setDialogOpen] = useState(false);
  const [mode, setMode] = useState("");
  const [dummyValue, setValue] = useState();
  const [DialogOpens, setDialogOpens] = useState(false);

  const initialValue = useSelector(
    (state) => state.filePaymentModify.filterValues.initialResponseRowValue
  );
  const remarks = useSelector(
    (state) => state.filePaymentModify.remarks.deleteRemarks
  );
  const updateValue = useSelector(
    (state) => state.filePaymentModify.gridValues.rows
  );
  const specialAccessHeaderMap = useSelector(
    (state) => state.specialAccess.specialAccessHeaderMap
  );

  const valueChanges =
    JSON.stringify(initialValue) === JSON.stringify(updateValue);
  const showDetailScreen = useSelector(
    (state) => state.filePaymentModify.HideComponents.showGridComponent
  );

  //Getting value from redux store
  const filterValue = useSelector(
    (state) => state.filePaymentModify.filterValues
  );
  //Getting Touch State
  const touchState = useSelector(
    (state) => state.filePaymentModify.filterValueTouched
  );
  const screenMode = useSelector(
    (state) => state.filePaymentModify.modes.screenMode
  );
  //Getting Valid State
  const validState = useSelector(
    (state) => state.filePaymentModify.filterValueIsValid
  );
  const userNames = useSelector((state) => state.branch.userName);
  const branchHasError = touchState.branchTouch && !validState.branchIsValid;

  const voucherNumberHasError =
    touchState.voucherNumberTouch && !validState.voucherNumberIsValid;

  const initialResponseRowValue = useSelector(
    (state) => state.filePaymentModify.filterValues.initialResponseRowValue
  );
  const approvalFlag = useSelector(
    (state) => state.filePaymentMode.mode.approvalFlag
  );
  //shortcut key
  const yesRef = useRef(null);
  const yesProcessRef = useRef(null);
  const cancelRef = useRef(null);
  const cancelProcessRef = useRef(null);
  const clearRef = useRef(null);
  const approveRef = useRef(null);
  const deleteRef = useRef(null);
  const modifyRef = useRef(null);
  const viewRef = useRef(null);
  const searchButtonRef = useRef(null);
  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, []);
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "paymentDetailFilter",
        })
      );
    }
  };

  const onKeyPressEventHandler = (event) => {
    let charCode = String.fromCharCode(event.which).toLowerCase();
    if (event.key === "Escape" || event.keyCode === 27) {
      // on escape press close the dialog.
      setDialogOpen(false);
    } else if (event.ctrlKey) {
      switch (charCode) {
        case "y":
          yesRef.current?.click();
          yesProcessRef.current?.click();
          break;
        case "q":
          cancelRef.current?.click();
          cancelProcessRef.current?.click();
          break;
        case "d":
          clearRef.current.click();
          break;
        case "f":
          searchButtonRef.current.click();
          break;
        case "u":
          approveRef.current.click();
          break;
        case "b":
          deleteRef.current.click();
          break;
        case "m":
          modifyRef.current.click();
          break;
        case "e":
          viewRef.current.click();
          break;
        default:
          break;
      }
    }
  };

  const [dialogMode, setDialogMode] = useState("");
  const onOkClickHandler = () => {
    switch (dialogMode) {
      case "ViewScreen":
        if (validState.branchIsValid && validState.voucherNumberIsValid) {
          dispatch(
            FilePaymentModifyReducerAction.updateShowGridCompponent(true)
          );
          dispatch(
            FilePaymentModifyReducerAction.updateScreenModes("ViewScreen")
          );
          dispatch(FilePaymentModifyReducerAction.updateRemarks(""));
          dispatch(FilePaymentModifyReducerAction.updateRows(initialValue));
          dispatch(
            FilePaymentModifyReducerAction.updateRemarksTouchHandler(false)
          );
        }
        break;
      case "EditScreen":
        EnableTouchState();
        if (validState.branchIsValid && validState.voucherNumberIsValid) {
          dispatch(
            FilePaymentModifyReducerAction.updateShowGridCompponent(true)
          );
          dispatch(
            FilePaymentModifyReducerAction.updateScreenModes("EditScreen")
          );
          dispatch(FilePaymentModifyReducerAction.updateRemarks(""));
          dispatch(FilePaymentModifyReducerAction.updateRows(initialValue));
        }
        dispatch(
          FilePaymentModifyReducerAction.updateRemarksTouchHandler(false)
        );
        break;
      case "DeleteScreen":
        EnableTouchState();
        if (validState.branchIsValid && validState.voucherNumberIsValid) {
          dispatch(
            FilePaymentModifyReducerAction.updateShowGridCompponent(true)
          );
          dispatch(
            FilePaymentModifyReducerAction.updateScreenModes("DeleteScreen")
          );
          dispatch(FilePaymentModifyReducerAction.updateRemarks(""));

          dispatch(FilePaymentModifyReducerAction.updateRows(initialValue));
        }
        dispatch(
          FilePaymentModifyReducerAction.updateRemarksTouchHandler(false)
        );
        break;
      case "ApprovalScreen":
        EnableTouchState();
        if (validState.branchIsValid && validState.voucherNumberIsValid) {
          dispatch(
            FilePaymentModifyReducerAction.updateShowGridCompponent(true)
          );
          dispatch(
            FilePaymentModifyReducerAction.updateScreenModes("ApprovalScreen")
          );
          dispatch(FilePaymentModifyReducerAction.updateRows(initialValue));
          dispatch(FilePaymentModifyReducerAction.updateRemarks(""));
          dispatch(
            FilePaymentModifyReducerAction.updateRemarksTouchHandler(false)
          );
        }
        break;
      default:
        break;
    }
    setDialogOpens(false);
  };
  //Methods
  const branchOnChangeHandler = (value) => {
    setMode("BranchMode");
    setValue(value);
    if (
      (showDetailScreen && screenMode === "EditScreen" && !valueChanges) ||
      (screenMode === "DeleteScreen" && remarks !== "")
    ) {
      setDialogOpen(true);
    } else {
      dispatch(FilePaymentModifyReducerAction.branchOnChangeResetHandler());
      dispatch(FilePaymentModifyReducerAction.updateBranchValue(value));
      if (value !== "" && value !== null) {
        dispatch(BranchAction.updateInitialLoad(false));
        dispatch(BranchAction.updateHeaderBranchDetails(value.label));
        getVoucherNumByBranch(value);
      }
    }
  };
  const ClearButtonHandler = () => {
    setMode("ClearButtonMode");
    if (
      (showDetailScreen && screenMode === "EditScreen" && !valueChanges) ||
      (screenMode === "DeleteScreen" && remarks !== "")
    ) {
      setDialogOpen(true);
    } else {
      dispatch(FilePaymentModifyReducerAction.updateBranchValue(null));
      dispatch(FilePaymentModifyReducerAction.branchOnChangeResetHandler());
      dispatch(FilePaymentModifyReducerAction.updateBranchIsTouched(false));
      dispatch(
        FilePaymentModifyReducerAction.updateVoucherNumberIsTouched(false)
      );
    }
  };
  const voucherNumberOnChangeHandler = (data) => {
    setValue(data);
    setMode("VoucherMode");
    if (
      (showDetailScreen && screenMode === "EditScreen" && !valueChanges) ||
      (screenMode === "DeleteScreen" && remarks !== "")
    ) {
      setDialogOpen(true);
    } else {
      dispatch(
        FilePaymentModifyReducerAction.voucherNumberOnChangeResetHandler()
      );
      if (data !== null) {
        dispatch(FilePaymentModifyReducerAction.updateVoucherNumberValue(data));
        getGridDataBasedOnVoucherNumber(data);
      } else {
        dispatch(FilePaymentModifyReducerAction.updateVoucherNumberValue(null));
      }
    }
  };
  const onOkButtonClickHandler = () => {
    if (mode === "BranchMode") {
      dispatch(FilePaymentModifyReducerAction.branchOnChangeResetHandler());
      dispatch(FilePaymentModifyReducerAction.updateBranchValue(dummyValue));
      dispatch(FilePaymentModifyReducerAction.updateRemarks(""));
      dispatch(FilePaymentModifyReducerAction.updateRemarksTouchHandler(false));
      if (dummyValue !== "" && dummyValue !== null) {
        dispatch(BranchAction.updateInitialLoad(false));
        dispatch(BranchAction.updateHeaderBranchDetails(dummyValue.label));
        getVoucherNumByBranch(dummyValue);
      }
      setDialogOpen(false);
    }
    if (mode === "ClearButtonMode") {
      dispatch(FilePaymentModifyReducerAction.updateBranchValue(null));
      dispatch(FilePaymentModifyReducerAction.branchOnChangeResetHandler());
      dispatch(FilePaymentModifyReducerAction.updateBranchIsTouched(false));
      dispatch(
        FilePaymentModifyReducerAction.updateVoucherNumberIsTouched(false)
      );
      dispatch(FilePaymentModifyReducerAction.updateRemarks(""));
      dispatch(FilePaymentModifyReducerAction.updateRemarksTouchHandler(false));
      setDialogOpen(false);
    }
    if (mode === "VoucherMode") {
      dispatch(
        FilePaymentModifyReducerAction.voucherNumberOnChangeResetHandler()
      );
      dispatch(FilePaymentModifyReducerAction.updateRemarks(""));
      dispatch(FilePaymentModifyReducerAction.updateRemarksTouchHandler(false));
      if (dummyValue !== null) {
        dispatch(
          FilePaymentModifyReducerAction.updateVoucherNumberValue(dummyValue)
        );
        getGridDataBasedOnVoucherNumber(dummyValue);
      } else {
        dispatch(FilePaymentModifyReducerAction.updateVoucherNumberValue(""));
      }

      setDialogOpen(false);
    }
    if (mode === "SearchMode") {
      dispatch(
        FilePaymentModifyReducerAction.updateRows(initialResponseRowValue)
      );
      setDialogOpen(false);
    }
  };
  const getGridDataBasedOnVoucherNumber = async (value) => {
    dispatch(FilePaymentModifyReducerAction.updateShowGridCompponent(false));
    try {
      const response = await axios.post(
        "/filepayment/getApplicationListByVoucherNum",
        {
          voucherNum: value,
          screenMode: "MODIFY",
        }
      );
      //Checking whether the voucher Number is approved or not
      const voucherApproved = response.data[0].approvalFlg;
      dispatch(
        FilePaymentModeReducerAction.updateApprovalFlag(voucherApproved)
      );

      //Dispatching voucher type and data
      dispatch(
        FilePaymentModifyReducerAction.updateFilterValues(response.data[0])
      );
      //Inserting unique id for grid
      const responseData = response.data.map((datas) => {
        return {
          ...datas,
          id: datas.filePaymentFavourId,
          screenMode: "MODIFY",
        };
      });
      dispatch(FilePaymentModifyReducerAction.updateRows(responseData));

      dispatch(
        FilePaymentModifyReducerAction.updateInitialResponseRowValue(
          responseData
        )
      );
    } catch {}
  };

  const getSelectedBranchCode = (branchValue) => {
    const branchWithCodes = GetBranchDetailsWithCode();
    const branchCodeValue = branchWithCodes.find((branch) => {
      return branch.label === branchValue;
    });
    return branchCodeValue.code;
  };

  const getVoucherNumByBranch = async (value) => {
    try {
      const branchCodeValue = getSelectedBranchCode(value.label);
      const response = await axios.post("/filepayment/getVoucherNumByBranch", {
        branch: value.label,
        branchCode: branchCodeValue,
      });
      const arr = response.data;
      const ids = arr.map((o) => o.voucherNum);
      const filtered = arr.filter(
        ({ voucherNum }, index) => !ids.includes(voucherNum, index + 1)
      );
      const responseData = filtered.map((data) => {
        return {
          label: `${data.voucherNum}${
            data.status === true ? " - Approved" : ""
          }`,
          value: data.voucherNum,
        };
      });
      dispatch(
        FilePaymentModifyReducerAction.updateVoucherNumberArray(responseData)
      );
    } catch {}
  };

  const getGlAccountBasedOnBranchCode = async (branchWithCode) => {
    const codes = branchWithCode.map((branches) => branches.code);
    const response = await axios.post("/filereceipt/getGLAccountDataByBranch", {
      shflApisModel: {
        apiCode: "FILE_GL_ACC_LOV_API",
        createdBy: userNames,
        lastModifiedBy: userNames,
      },
      branchCodes: codes,
    });
    if (response.status === 200) {
      dispatch(
        FilePaymentModifyReducerAction.updateAllBranchGlAccounts(response.data)
      );
    }
  };
  const EnableTouchState = () => {
    dispatch(FilePaymentModifyReducerAction.updateBranchIsTouched(true));
    dispatch(FilePaymentModifyReducerAction.updateVoucherNumberIsTouched(true));
  };
  //Mode Button Handlers
  const viewButtonHandler = () => {
    if (
      (showDetailScreen && screenMode === "EditScreen" && !valueChanges) ||
      (screenMode === "DeleteScreen" && remarks !== "")
    ) {
      setDialogOpens(true);
      setDialogMode("ViewScreen");
    } else {
      EnableTouchState();
      if (validState.branchIsValid && validState.voucherNumberIsValid) {
        dispatch(FilePaymentModifyReducerAction.updateShowGridCompponent(true));
        dispatch(
          FilePaymentModifyReducerAction.updateScreenModes("ViewScreen")
        );
      }
    }
  };
  const editButtonHandler = () => {
    if (
      (showDetailScreen && screenMode === "EditScreen" && !valueChanges) ||
      (screenMode === "DeleteScreen" && remarks !== "")
    ) {
      setDialogOpens(true);
      setDialogMode("EditScreen");
    } else {
      EnableTouchState();
      if (validState.branchIsValid && validState.voucherNumberIsValid) {
        dispatch(FilePaymentModifyReducerAction.updateShowGridCompponent(true));
        dispatch(
          FilePaymentModifyReducerAction.updateScreenModes("EditScreen")
        );
      }
    }
  };
  const deleteButtonHandler = () => {
    if (
      (showDetailScreen && screenMode === "EditScreen" && !valueChanges) ||
      (screenMode === "DeleteScreen" && remarks !== "")
    ) {
      setDialogOpens(true);
      setDialogMode("DeleteScreen");
    } else {
      EnableTouchState();
      if (validState.branchIsValid && validState.voucherNumberIsValid) {
        dispatch(FilePaymentModifyReducerAction.updateShowGridCompponent(true));
        dispatch(
          FilePaymentModifyReducerAction.updateScreenModes("DeleteScreen")
        );
      }
    }
  };
  const approveButtonHandler = () => {
    if (
      (showDetailScreen && screenMode === "EditScreen" && !valueChanges) ||
      (screenMode === "DeleteScreen" && remarks !== "")
    ) {
      setDialogOpens(true);
      setDialogMode("ApprovalScreen");
    } else {
      EnableTouchState();
      if (validState.branchIsValid && validState.voucherNumberIsValid) {
        dispatch(FilePaymentModifyReducerAction.updateShowGridCompponent(true));
        dispatch(
          FilePaymentModifyReducerAction.updateScreenModes("ApprovalScreen")
        );
      }
    }
  };
  useEffect(() => {
    const branchArr = GetBranchDetails();
    const branchWithCode = GetBranchDetailsWithCode();
    getGlAccountBasedOnBranchCode(branchWithCode);
    dispatch(FilePaymentModifyReducerAction.updateBranchArray(branchArr));
    dispatch(
      FilePaymentModifyReducerAction.updateBrachArrayWithCode(branchWithCode)
    );
    return () => {
      dispatch(FilePaymentModifyReducerAction.updateShowGridCompponent(false));
    };
  }, []);
  return (
    <Box>
      <AccordianContainer
        title="Refund"
        initialOpen={true}
        sx={{ margin: "8px !important" }}
      >
        <Box
          sx={{
            marginBottom: "8px",
            marginTop: "-1%",
            display: "flex",
            gap: "8px",
            justifyContent: "flex-end",
          }}
        >
          {specialAccessHeaderMap.filePaymentView && (
            <Tooltip title="Ctrl+E">
              <IconButton
                aria-label="View"
                color="primary"
                onClick={viewButtonHandler}
                ref={viewRef}
              >
                <RemoveRedEyeIcon />
              </IconButton>
            </Tooltip>
          )}
          {specialAccessHeaderMap.filePaymentModify && (
            <Tooltip title="Ctrl+M">
              <IconButton
                aria-label="Modify"
                color="primary"
                onClick={editButtonHandler}
                ref={modifyRef}
                disabled={approvalFlag}
              >
                <ModeEditIcon />
              </IconButton>
            </Tooltip>
          )}
          {specialAccessHeaderMap.filePaymentDelete && (
            <Tooltip title="Ctrl+B">
              <IconButton
                aria-label="Delete"
                color="primary"
                onClick={deleteButtonHandler}
                ref={deleteRef}
                disabled={approvalFlag}
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          )}
          {specialAccessHeaderMap.filePaymentApproval && (
            <Tooltip title="Ctrl+U">
              <IconButton
                aria-label="Approve"
                color="primary"
                onClick={approveButtonHandler}
                ref={approveRef}
                disabled={approvalFlag}
              >
                <CheckCircleIcon />
              </IconButton>
            </Tooltip>
          )}

          <Tooltip title="Ctrl+D">
            <IconButton
              aria-label="Clear"
              color="primary"
              onClick={ClearButtonHandler}
              ref={clearRef}
            >
              <HighlightOffIcon />
            </IconButton>
          </Tooltip>
        </Box>
        <Box sx={{ marginTop: "-1%" }}>
          <Grid container rowSpacing={0} columnSpacing={2}>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomAutoComplete
                variant="standard"
                type="text"
                placeholder="Select Branch"
                label="Branch"
                required={true}
                autoCompleteValues={filterValue.branch}
                value={filterValue.branchValue ? filterValue.branchValue : null}
                onChange={(e, value) => {
                  branchOnChangeHandler(value);
                }}
                onBlur={() => {
                  dispatch(
                    FilePaymentModifyReducerAction.updateBranchIsTouched(true)
                  );
                }}
              />
              {branchHasError && <p className="error"> Please Select Branch</p>}
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomAutoComplete
                variant="standard"
                type="text"
                placeholder="Select Voucher Number"
                label="Voucher Number"
                required={true}
                autoCompleteValues={filterValue.VoucherNumberArray}
                value={filterValue.voucherNumberValue}
                onChange={(e, data) => {
                  voucherNumberOnChangeHandler(
                    data !== null ? data.value : null
                  );
                }}
                onBlur={() => {
                  dispatch(
                    FilePaymentModifyReducerAction.updateVoucherNumberIsTouched(
                      true
                    )
                  );
                }}
              />
              {voucherNumberHasError && (
                <p className="error"> Please Select Voucher Number</p>
              )}
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomAutoComplete
                variant="standard"
                type="text"
                placeholder="Select Payment Type"
                label="Payment Type"
                autoCompleteValues={filterValue.paymentTypeArray}
                value={filterValue.paymentType}
                disabled={true}
              />
            </Grid>
            {filterValue.paymentType === "Fund Transfer" && (
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomAutoComplete
                  variant="standard"
                  type="text"
                  placeholder="Select Fund Transfer Mode"
                  label="Fund Transfer Mode"
                  autoCompleteValues={["NEFT", "RTGS"]}
                  value={filterValue.fundTransferMode}
                  disabled={true}
                />
              </Grid>
            )}

            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomAutoComplete
                variant="standard"
                type="text"
                autoCompleteValues={[]}
                placeholder="Select Payment Bank / Cash Account"
                label="Payment Bank / Cash Account"
                value={filterValue.paymentBankOrCash}
                disabled={true}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomDateField
                label="Voucher Date"
                variant="standard"
                placeholder="Enter Voucher Date"
                value={filterValue.voucherDate}
                disabled={true}
              />
            </Grid>
          </Grid>
        </Box>
      </AccordianContainer>
      <Dialog open={DialogOpens}>
        <DialogTitle>
          <h4>Confirmation</h4>
        </DialogTitle>
        <DialogContent>
          Payment process is not completed. Do you want to change and continue?
        </DialogContent>
        <DialogActions>
          <Tooltip title="Ctrl+Q" placement="top">
            <Button
              onClick={() => {
                setDialogOpens(false);
              }}
              ref={cancelRef}
            >
              Cancel
            </Button>
          </Tooltip>
          <Tooltip title="Ctrl+Y" placement="top">
            <Button onClick={onOkClickHandler} ref={yesRef}>
              Yes
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
      <Dialog open={DialogOpen}>
        <DialogTitle>
          <h4>Confirmation</h4>
        </DialogTitle>
        <DialogContent>
          Payment process not completed. Do you want to change and continue?
        </DialogContent>
        <DialogActions>
          <Tooltip title="Ctrl+Q" placement="top">
            <Button
              onClick={() => {
                setDialogOpen(false);
              }}
              ref={cancelProcessRef}
            >
              Cancel
            </Button>
          </Tooltip>
          <Tooltip title="Ctrl+Y" placement="top">
            <Button onClick={onOkButtonClickHandler} ref={yesProcessRef}>
              YES
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default FilePaymentFIl;
